import { render } from "./pages-modal.vue?vue&type=template&id=1d5e6dcb"
import script from "./pages-modal.vue?vue&type=script&lang=js"
export * from "./pages-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__